import { useEffect, useRef, useState } from "react";

const TurnstileWidget = ({ sitekey, onVerify }) => {
    const [error, setError] = useState(null);
    const widgetRef = useRef(null);
    const turnstileRef = useRef(null);

    useEffect(() => {
      const loadTurnstile = () => {
        try {
          // Check if Turnstile is loaded
          if (!window.turnstile) {
            throw new Error('Turnstile script failed to load');
          }
  
          // Check if container exists
          if (!widgetRef.current) {
            throw new Error('Widget container not found');
          }
  
          // Clear previous widget if exists
          if (turnstileRef.current) {
            window.turnstile.remove(turnstileRef.current);
          }
  
          // Render new widget
          turnstileRef.current = window.turnstile.render(widgetRef.current, {
            sitekey: sitekey,
            callback: (token) => {
              setError(null);
              onVerify(token);
            },
            'error-callback': (errorCode) => {
              handleTurnstileError(errorCode);
            }
          });
  
        } catch (err) {
          handleTurnstileError(err.message);
        }
      };
  
      const handleTurnstileError = (error) => {
        console.error('Turnstile Error:', error);
        setError(getErrorMessage(error));
        onVerify(null);
      };
  
      const getErrorMessage = (error) => {
        if (error.includes('110200')) {
          return 'CAPTCHA validation not available in development mode';
        }
        if (error.includes('failed to load')) {
          return 'Could not load CAPTCHA service. Please check your connection.';
        }
        return 'CAPTCHA verification failed. Please refresh the page.';
      };
  
      // Load script if not already loaded
      if (!window.turnstile) {
        const script = document.createElement('script');
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
        script.async = true;
        script.defer = true;
        script.onerror = () => handleTurnstileError('Failed to load Turnstile script');
        document.head.appendChild(script);
        script.onload = loadTurnstile;
      } else {
        loadTurnstile();
      }
  
      // Cleanup
      return () => {
        if (turnstileRef.current && window.turnstile) {
          window.turnstile.remove(turnstileRef.current);
        }
      };
    }, [sitekey, onVerify]);
  
    return <div ref={widgetRef} />;
}

export default TurnstileWidget;